import ReactDOM from 'react-dom/client';
import App from '@/containers/App';
import AppContext from '@keyslabor/shared/containers/AppContext';

import './global.css';
// @ts-expect-error virtual module provided by mswAutoImportPlugin
import 'virtual:msw';

import * as Sentry from '@sentry/react';

// import 'react-datepicker/dist/react-datepicker.css';
// require('react-datepicker/dist/react-datepicker.css');

// Unregister any existing service workers from previous deployments
// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.getRegistrations().then((registrations) => {
//     registrations.forEach((registration) => {
//       registration.unregister();
//     });
//   });
// }

import { registerSW } from 'virtual:pwa-register';
import { isProd, isStage } from '@/utils/environment.ts';

const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    console.log('onNeedRefresh');
    updateSW(true); // активує новий SW і перезавантажує сторінку
  },
  onRegisteredSW(_url, r) {
    console.log('onRegisteredSW');
    r &&
      setInterval(
        () => {
          console.log('onRegisteredSW');

          r.update();
        },
        60 * 60 * 1000
      ); // раз/год перевірка
  },
});
//
// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker
//     .getRegistrations()
//     .then((rs) => Promise.all(rs.map((r) => r.unregister())))
//     .catch(() => {});
//   if (window.caches?.keys) {
//     caches
//       .keys()
//       .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
//       .catch(() => {});
//   }
// }

const root = document.getElementById('root');

let sentryDsn = import.meta.env.VITE_SENTRY_LOCAL_DNS;
if (isProd) {
  sentryDsn = import.meta.env.VITE_SENTRY_PROD_DNS;
} else if (isStage) {
  sentryDsn = import.meta.env.VITE_SENTRY_STAGE_DNS;
}

Sentry.init({
  dsn: sentryDsn,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  enabled: !!sentryDsn,
});

if (root) {
  ReactDOM.createRoot(root).render(
    <AppContext>
      <App />
    </AppContext>
  );
}
